export const pathName = 'https://kiddlepass-company-api.herokuapp.com';
// export const pathName = 'http://localhost:3001';
export default pathName;
